import { render } from "./Castle.vue?vue&type=template&id=60dcd1a0"
const script = {}

import "./Castle.vue?vue&type=style&index=0&id=60dcd1a0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__